<template>
    <div class="page-content" id="p">
        <div class="detail-body">
            <div v-loading="loading" class="detail-content">
                <div class="content-head">
                    <div class="detail-title">
                        <div class="title-name">{{detail.house.title}}</div>
                        <div class="title-right" @click="setCollection('del')" v-if="detail.house.collect===1"
                             style="margin-left: auto;">
                            <i class="el-icon-star-off color-red"></i>
                            <span class="color-red">已收藏</span>
                        </div>
                        <div class="title-right" @click="setCollection('add')" v-else style="margin-left: auto;">
                            <i class="el-icon-star-off"></i>
                            收藏
                        </div>

                        <el-popover
                                placement="bottom-start"
                                title="分享"
                                width="200"
                                trigger="hover">
                            <div slot="reference" class="title-right">
                                <i class="el-icon-share"></i>
                                分享
                            </div>
                            <div data-sites="qzone, qq, weibo, wechat" class="social-share"></div>
                        </el-popover>

                    </div>
                    <div class="head-address">
                        <i class="el-icon-location"></i>
                        <div class="f-14">{{detail.house.address}}</div>
                        <img src="./../assets/img/bmap.jpg" class="bmap-img" alt="">
                        <div class="f-l4 cur-p color-red" @click="lookMap">查看地图</div>
                    </div>
                    <div class="swiper-content">
                        <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
                            <swiper-slide class="swiper-slide" v-for="(item,index) in detail.house.image" :key="index">
                                <img :src="`/api/v1/file/${item}`" alt="">
                            </swiper-slide>
                        </swiper>
                        <!-- swiper2 Thumbs -->
                        <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
                            <swiper-slide class="swiper-slide" v-for="(item,index) in detail.house.image" :key="index">
                                <img :src="`/api/v1/file/${item}?w=126&h=70`" alt="">
                            </swiper-slide>
                        </swiper>
                    </div>
                    <div class="head-bottom">
                        <img class="head-bottom-icon" src="./../assets/img/ii1.jpg" alt="">
                        <div class="icon-text">{{detail.house.house_type}}</div>
                        <img class="head-bottom-icon" src="./../assets/img/ii2.jpg" alt="">
                        <div class="icon-text">可住人数{{detail.house.max_people}}人</div>
                        <img class="head-bottom-icon" src="./../assets/img/ii3.jpg" alt="">
                        <div class="icon-text">{{detail.house.bed_count}}张床</div>
                        <img class="head-bottom-icon" src="./../assets/img/ii4.jpg" alt="">
                        <div class="icon-text">{{detail.house.toilet}}</div>
                    </div>
                </div>
                <div class="content-body">
                    <div class="content-title">房东推荐时间</div>
                    <div class="content-text">入住：
                        {{detail.house.check_in_time?detail.house.check_in_time.substr(0,5):''}}
                    </div>
                    <div class="content-text">退房：
                        {{detail.house.check_out_time?detail.house.check_out_time.substr(0,5):''}}
                    </div>

                    <div class="content-title">房源介绍</div>
                    <div class="content-text" v-html="content"></div>
                    <div class="color-grays f-14 mt-10 mb-10 tran-content">
                        是否使用谷歌翻译
                        <template v-if="!traning">
                            <el-link class="ml-20" type="primary" @click="trans('zh')">翻译为中文</el-link>
                            <el-link class="ml-10" type="primary" @click="trans('jp')">翻译为日文</el-link>
                        </template>
                        <el-link v-else class="ml-10" type="primary">翻译中...</el-link>
                    </div>
                    <div class="content-text" v-for="(item,index) in transList" :key="index">{{item.dst}}</div>

                    <div class="content-title">相关信息</div>
                    <div class="content-text">{{detail.house.toilet}}</div>
                    <div v-for="(item,index) in detail.house.num" :key="index" class="content-text">{{item}}</div>
                    <div class="content-text">最短入住天数：{{detail.house.min_check_in_days}}</div>
                    <div class="content-text">最大入住人数：{{detail.house.max_people}}</div>

                    <div class="content-title">配套设施</div>
                    <div class="icon-list">
                        <div class="icon-list-item" v-for="(item,index) in detail.house.facility" :key="index">
                            <i class="iconfont" :class="item.img"></i>
                            <div style="margin-top: 10px;">{{item.name}}</div>
                        </div>
                    </div>

                    <div class="content-title">入住规则</div>
                    <div class="content-text" v-html="checkInRules"></div>

                    <div class="content-title">额外费用（{{detail.money.name}}）</div>
                    <div class="content-text">清洁费：
                        <span class="color-red">{{detail.house.cleaning|parseMoney}}</span>
                    </div>
                    <div class="content-text">额外人员费用：
                        <span class="color-red">{{detail.house.capitation|parseMoney}}</span>（超出{{detail.house.people}}人后）
                    </div>
                    <div class="content-text">在线押金：
                        <span class="color-red">{{detail.house.deposit|parseMoney}}</span>
                    </div>

                    <div class="content-title">折扣</div>
                    <div class="content-text">入住7晚以上费用为原价的：
                        <span class="color-red">{{detail.house.discount7}}%</span>
                    </div>
                    <div class="content-text">入住30晚以上费用为原价的：
                        <span class="color-red">{{detail.house.discount30}}%</span>
                    </div>

                    <div class="content-title">退订政策</div>
                    <div class="content-text">{{detail.house_rules}}</div>

                    <div class="content-title" id="houseMap">房源位置</div>
                    <baidu-map class="map-content"
                               scroll-wheel-zoom
                               :center="{lng: detail.house.lon,lat: detail.house.lat}"
                               :zoom="14">
                        <bm-circle v-if="detail.house" :center="{lng: detail.house.lon,lat: detail.house.lat}"
                                   :radius="500"
                                   :stroke-opacity="0"
                                   fillColor="blue"
                                   stroke-color="none"
                                   :fill-opacity="0.3"></bm-circle>
                    </baidu-map>

                    <div class="content-title">相关景点</div>
                    <div class="content-title">相关温泉</div>
                    <div class="content-title">相关美食</div>
                </div>
                <div v-if="detail.house_like.length" class="content-title" style="padding: 0 20px;">相似房源</div>
                <div v-if="detail.house_like.length" class="card-content" style="width: 100%;">
                    <template v-for="(item,index) in detail.house_like">
                        <HouseCard :key="index" :item="item" v-if="index<12"></HouseCard>
                    </template>
                </div>
            </div>
            <div class="detail-right">
                <div class="detail-right-content">
                    <div class="right-title">房源预定信息</div>
                    <div class="f-14 content-text">
                        <span class="color-red">
                            {{detail.house.price|parseMoney}}（约{{detail.house.price*exchangeJP|parseNum}}{{otherMoneyNanme}}）
                        </span>/晚
                    </div>
                    <div class="content-text">{{detail.house.min_check_in_days}}晚起订</div>
                    <div class="evaluate-content">
                        <el-rate :value="+detail.house.star|| 0"
                                 disabled
                                 show-score
                                 disabled-void-color="#cccccc"
                                 text-color="#ff9900"
                                 style="display: flex;justify-content: flex-start;align-items: center"
                                 score-template="{value}"></el-rate>
                        <div class="f-14">{{detail.house.evaluate_count}} 评价</div>
                    </div>
                    <div class="btn-item bc-color-red color-fff" @click="toPay">申请预约</div>
                </div>
                <div class="detail-right-content">
                    <div class="right-title">房东信息</div>
                    <div class="img-row" @click="toLandlordDetail">
                        <img v-if="detail.landlord" :src="`/api/v1/file/${detail.landlord.portrait}`" alt="">
                        <div class="f-16 nick-name">{{detail.landlord.nickname}}</div>
                    </div>
                    <div class="btn-item bc-color-yellow color-fff" @click="handlerLink">联系房东</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HouseCard from "@/components/HouseCard";

    export default {
        name: "houseDetail",
        components: {HouseCard},
        data() {
            return {
                id: '',
                loading: false,
                traning: false,
                detail: {
                    house: '',
                    landlord: '',
                    house_like: [],
                    money: {},
                    money2: []
                },
                content: '',
                checkInRules: '',
                swiperOptionTop: {
                    loop: true,
                    loopedSlides: 5, // looped slides should be the same
                    spaceBetween: 10
                },
                swiperOptionThumbs: {
                    loop: true,
                    spaceBetween: 10,
                    loopedSlides: 5, // looped slides should be the same
                    slidesPerView: 5,
                    touchRatio: 0.2,
                    direction: 'vertical',
                    slideToClickedSlide: true,
                    centeredSlides: false
                },
                transList: [],
                config: {
                    title: '', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
                    description: '', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
                    image: '', // 图片, 默认取网页中第一个img标签
                    sites: ['qzone', 'qq', 'weibo', 'wechat']
                }
            }
        },
        computed: {
            exchangeJP() {
                let cRate = this.detail.money.ratio
                let jp = this.detail.money2.find((value) => value.coin_name !== this.detail.money.coin_name)
                if (!jp) return 0;
                let ratio = +jp.ratio;
                return ratio / cRate
            },
            otherMoneyNanme() {
                if (this.detail.money.coin_name === 'JPY') {
                    return '人民币'
                }
                return '日元'
            }
        },
        mounted() {
            this.id = this.$route.query.id;
            this.getHouseDetails();
            setTimeout(() => {
                app.scrollTop = 0;
            }, 0)
        },
        methods: {
            handlerLink() {
                this.$store.commit('initChartData', {
                    id: this.detail.landlord.landlord_id,
                    info: {
                        nickname: this.detail.landlord.nickname,
                        avar: this.detail.landlord.portrait,
                    }
                })
                this.$eventBus.$emit('openChart', {
                    id: this.detail.landlord.landlord_id,
                    name: this.detail.landlord.nickname
                })
            },
            async trans(to) {
                this.traning = true;
                let [e, data] = await this.$api.transApi({to, q: this.detail.house.content})
                this.traning = false;
                this.transList = data.result;
            },
            async getHouseDetails() {
                this.loading = true;
                let [e, data] = await this.$api.getHouseDetailsApi({
                    house_id: this.id
                })
                this.loading = false;
                this.detail = data.result;
                if (this.detail.house.content) {
                    this.content = this.detail.house.content.replace(/\n/g, '<br>')
                }
                if (this.detail.house.check_in_rules) {
                    this.checkInRules = this.detail.house.check_in_rules.replace(/\n/g, '<br>')
                }
                this.$nextTick(() => {
                    const swiperTop = this.$refs.swiperTop.$swiper
                    const swiperThumbs = this.$refs.swiperThumbs.$swiper
                    swiperTop.on('slideChange', (r) => {
                        swiperThumbs.slideToLoop(r.realIndex, 500)
                    })
                    swiperThumbs.on('slideChange', (r) => {
                        swiperTop.slideToLoop(r.realIndex, 500)
                    })
                })

                this.config.title = this.detail.house.title;
                this.config.description = this.detail.house.title;
                this.config.image = this.detail.house.cover;
                socialShare('.social-share', this.config)
            },
            lookMap() {
                houseMap.scrollIntoView()
            },
            async setCollection(method) {
                let [e, data] = await this.$api.setCollectionApi({
                    id: this.detail.house.id,
                    mark: 0,
                    method
                })
                if (data.code === 200) {
                    if (method === 'add') {
                        this.detail.house.collect = 1;
                    } else {
                        this.detail.house.collect = 0;
                    }
                } else {
                    this.$message.warning(data.error)
                }
            },
            toLandlordDetail() {
                this.$router.push({path: '/landlordDetail', query: {id: this.detail.landlord.landlord_id}})
            },
            toPay(){
                this.$store.commit('updateParamsData', this.detail.house)
                this.$router.push({path: '/houseOrderPay'})
            }
        }
    }
</script>

<style scoped lang="less">
    .page-content {
        display: flex;
        padding-bottom: 30px;
    }

    .detail-body {
        width: 1200px;
        margin-top: 20px;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: center;
        align-items: flex-start;
    }

    .detail-content {
        width: 900px;
        margin-right: 20px;
        background-color: #ffffff;
        box-shadow: 3px 3px 6px #A6A6A6;

        .content-head {
            width: 100%;
            padding: 30px;
            box-sizing: border-box;
            border-bottom: 1px solid #e2e2e2;

            .detail-title {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .title-name {
                    font-size: 26px;
                }

                .title-right {
                    padding-left: 20px;
                    cursor: pointer;
                    flex-shrink: 0;
                }
            }

            .head-address {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: #949494;
                margin: 4px 0;

                .bmap-img {
                    margin-left: 20px;
                    margin-right: 10px;
                }
            }

            .head-bottom {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding-top: 20px;

                .head-bottom-icon {
                    width: 30px;
                    height: 30px;
                    object-fit: contain;
                    margin-right: 10px;
                }

                .icon-text {
                    margin-right: 20px;
                }
            }
        }

        .content-body {
            padding: 10px 30px 30px 30px;
            box-sizing: border-box;
            width: 100%;
            text-align: left;
            border-bottom: 1px solid #e2e2e2;
        }
    }

    .detail-right {
        flex: 1;
        position: sticky;
        top: 100px;
        left: 0;
        z-index: 2;

        .detail-right-content {
            padding: 20px;
            background-color: #ffffff;
            box-shadow: 3px 3px 6px #A6A6A6;
            text-align: left;
            margin-bottom: 20px;

            .right-title {
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 10px;
            }

            .evaluate-content {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .btn-item {
                width: 100%;
                height: 40px;
                line-height: 40px;
                font-size: 16px;
                text-align: center;
                margin-top: 20px;
                cursor: pointer;
            }

            .img-row {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-bottom: 10px;
                cursor: pointer;

                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 100%;
                    object-fit: cover;
                    margin-right: 10px;
                }

                .nick-name {
                    font-weight: bold;
                }

                &:hover {
                    .nick-name {
                        color: #e44646 !important;
                    }
                }
            }
        }
    }

    .swiper-content {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .gallery-top {
            width: 694px;
            height: 390px;
            margin-right: 20px;
        }

        .gallery-thumbs {
            width: 126px;
            height: 390px;
        }

        .swiper-slide {
            width: 100%;
            height: 100%;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover
            }
        }

    }

    .content-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        margin-top: 20px;
        text-align: left;
        box-sizing: border-box;
    }

    .content-text {
        font-size: 14px;
        line-height: 2;
    }

    .icon-list {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-flow: wrap;

        .icon-list-item {
            color: #949494 !important;
            width: 10%;
            margin-bottom: 20px;
            text-align: center;

            .iconfont {
                font-size: 38px;
            }
        }
    }

    .map-content {
        width: 840px;
        height: 500px;
        position: relative;
    }
</style>
